import type { UserRole } from '@/types/auth'

export const ROLE_PERSPECTIVE_STORAGE_KEY = 'clinic_ms_system_admin_view_as_role'

const ALL_ROLES: readonly UserRole[] = [
  'SystemAdmin',
  'Management',
  'Doctor',
  'Nurse',
  'Dispensary',
  'Accountant',
  'Patient',
] as const

function isValidPreviewRole(value: unknown): value is UserRole {
  return (
    typeof value === 'string' &&
    (ALL_ROLES as readonly string[]).includes(value) &&
    value !== 'SystemAdmin'
  )
}

/** Session-only persistence so preview survives refresh but not a cleared session. */
export function readRolePerspectiveFromStorage(): UserRole | null {
  if (typeof window === 'undefined') return null
  try {
    const raw = sessionStorage.getItem(ROLE_PERSPECTIVE_STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as unknown
    return isValidPreviewRole(parsed) ? parsed : null
  } catch {
    return null
  }
}

export function clearRolePerspectiveStorage(): void {
  if (typeof window === 'undefined') return
  try {
    sessionStorage.removeItem(ROLE_PERSPECTIVE_STORAGE_KEY)
  } catch {
    /* noop */
  }
}

export function writeRolePerspectiveToStorage(role: UserRole | null): void {
  if (typeof window === 'undefined') return
  try {
    if (role === null || role === 'SystemAdmin') {
      sessionStorage.removeItem(ROLE_PERSPECTIVE_STORAGE_KEY)
    } else {
      sessionStorage.setItem(ROLE_PERSPECTIVE_STORAGE_KEY, JSON.stringify(role))
    }
  } catch {
    /* noop */
  }
}
